import { useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import ListadoPresupuestos from '../../components/presupuestos/ListadoPresupuestos';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import ContactosHubspot from '../../components/presupuestos/ContactosHubspot';

const Presupuestos = () => {
  useTituloCabecera('Presupuestos', 'Gestión de presupuestos');
  const [activeTab, setActiveTab] = useState('presupuestos');

  return (
    <div>
      <Nav tabs style={{ marginBottom: '16px' }}>
        <NavItem>
          <NavLink
            className={activeTab === 'presupuestos' ? 'active' : ''}
            onClick={() => setActiveTab('presupuestos')}
            style={{ cursor: 'pointer' }}
          >
            Presupuestos
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === 'hubspot' ? 'active' : ''}
            onClick={() => setActiveTab('hubspot')}
            style={{ cursor: 'pointer' }}
          >
            Clientes HubSpot
          </NavLink>
        </NavItem>
      </Nav>
      {activeTab === 'presupuestos' && <ListadoPresupuestos />}
      {activeTab === 'hubspot' && <ContactosHubspot />}
    </div>
  );
};

export default Presupuestos;
